module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("List of Figures")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch2fig1"
    }
  }, [_vm._v("Figure 2-1 Ration Table")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch2fig2"
    }
  }, [_vm._v("Figure 2-2 Staple Food Pie Chart")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-1 Boot Features")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-2 Names for Fuel in Other Languages")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-3 Temperature Ratings for Sleeping Bags")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-4 Internal vs. External Frame Packs")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3-5 Pack Volume According to Use")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4-1 The Economical Wardrobe")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-1 Number of Backpackers Age 16 and Older")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-2 National Park Recreational Visits 1926-1996")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5-3 Camping Surfaces")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-1 Water Loss as a Percentage of Body Weight Related to Performance and Symptoms")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6fig2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 6-2 Recommended Daily Water Intake According to Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 10-1 Cloud Types")])]), _vm._v(" "), _c('p', {
    staticClass: "lista"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 11-1 The Six Most Common Food-Borne Illnesses")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18948ca1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/list.vue
// module id = 75
// module chunks = 0